import React from 'react';
import { Link } from 'react-scroll';
import Typed from "react-typed";
// import { BrowserRouter, Route, Link } from "react-router-dom";


const Header = () => {
    return (
        <div id="home" className="header-wrapper">
            <div className="main-info">
                <h1>Hi <br /> I Am Yuvaraj</h1>
                <Typed
                    className="typed-text"
                    strings={["Web Designer", "Full-Stack Developer", "Android App Developer", "Python Developer"]}
                    typeSpeed={40}
                    backSpeed={60}
                    loop
                />
                <Link smooth={true} to="contacts" className="btn-main-offer">Contact-me</Link>
            
            </div>

        </div>

    )
}

export default Header
